import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { authHeader } from "../../common/apis/authHeader";
import axiosBaseURL from "../../common/apis/axiosBaseURL";
import HandleError from "../../common/apis/HandleError";
import { apiVersion } from "../../common/apis/apiVersion";

export const SeriesCricketListingAsyncCall = createAsyncThunk(
    "series/SeriesCricketListingAsyncCall",
    async (values) => {
        try {
            const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/match/cricket/series", values, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const SeriesFootballListingAsyncCall = createAsyncThunk(
    "match/SeriesFootballListingAsyncCall",
    async (values) => {
        try {
            const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/match/football/series", values, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const PoolSeriesContestAsyncList = createAsyncThunk(
    "series/PoolSeriesContestAsyncList",
    async (value) => {
        try {
            const response = await axiosBaseURL.post(`/app/${apiVersion.v1}/pool/series/${value.type}/pool_contest_list`, value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const SeriesTeamAsyncList = createAsyncThunk(
    "series/SeriesTeamAsyncList",
    async (value) => {
        try {
            const response = await axiosBaseURL.post(`/app/${apiVersion.v1}/match/sereis_player_list?page=${value.page}&limit=${value.rowsPerPage}`, value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const ContestSeriesSaveTeamAction = createAsyncThunk(
    "series/ContestSeriesSaveTeamAction",
    async (value) => {
        try {
            const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/match/save_series_player", value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const saveSubstitutePlayer = createAsyncThunk(
    "series/saveSubstitutePlayer",
    async (value) => {
        try {
            const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/match/add_substitute_player_series", value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);


export const updateSubstitutePlayer = createAsyncThunk(
    "series/updateSubstitutePlayer",
    async (value) => {
        try {
            const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/match/update_substitute_player_series", value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);


export const SeriesMyContestListAction = createAsyncThunk(
    "series/SeriesMyContestListAction",
    async (value) => {
        try {
            const response = await axiosBaseURL.post(`/app/${apiVersion.v1}/pool/series/${value.type}/mypool`, value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const SeriesCreatePrivatecontest = createAsyncThunk(
    "series/SeriesCreatePrivatecontest",
    async (value) => {
        try {
            const response = await axiosBaseURL.post(`/app/${apiVersion.v1}/pool/sereis/privatecontest/save`, value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const SeriesMypicks = createAsyncThunk(
    "series/SeriesMypicks",
    async (value) => {
        try {
            const response = await axiosBaseURL.post(`/app/${apiVersion.v1}/match/${value.type}/seriesteam`, value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const SeriesContestPrizePreviewAction = createAsyncThunk(
    "series/SeriesContestPrizePreviewAction",
    async (value) => {
        try {
            const response = await axiosBaseURL.post(`/app/${apiVersion.v1}/pool/confirm_join_pre_series`, value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const SeriesJoinContestAction = createAsyncThunk(
    "series/SeriesJoinContestAction",
    async (value) => {
        try {
            const response = await axiosBaseURL.post(`/app/${apiVersion.v1}/pool/join_pool_series`, value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const PoolSeriesContestDetailAsyncList = createAsyncThunk(
    "series/PoolSeriesContestDetailAsyncList",
    async (value) => {
        try {
            const response = await axiosBaseURL.post(`app/pool/series/${value.type}/pool_detail`, value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const SeriesCloneMyPicksAction = createAsyncThunk(
    "series/SeriesCloneMyPicksAction",
    async (value) => {
        try {
            const response = await axiosBaseURL.post(`/app/${apiVersion.v1}/match/${value.type}/series/clone_player_list`, value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const getSeriesPlayerListIDAction = createAsyncThunk(
    "series/getSeriesPlayerListIDAction",
    async (value) => {
        try {
            const response = await axiosBaseURL.post(`/app/${apiVersion.v1}/match/${value.type}/user_match_player_list`, value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const EditSeriesPicksSaveAction = createAsyncThunk(
    "series/EditSeriesPicksSaveAction",
    async (value) => {
        try {
            const response = await axiosBaseURL.post(`/app/${apiVersion.v1}/match/edit_series_player_list`, value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

export const ContestSeriesMyPortfolioAction = createAsyncThunk(
    "match/ContestSeriesMyPortfolioAction",
    async (value) => {
        try {
            const response = await axiosBaseURL.post(`/app/${apiVersion.v1}/match/${value.type}/series/myportfolio`, value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);


export const SeriesMatchList = createAsyncThunk(
    "series/SeriesMatchList",
    async (value) => {
        try {
            const response = await axiosBaseURL.post(`/app/${apiVersion.v1}/match/series_match_list?page=${value.page}&limit=${value.rowsPerPage}`, value, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

const initialState = {
    series_cricket_list: {},
    series_football_list: {},
    pool_series_list: {},
    series_contest_team_list: {},
    series_save_team: {},
    series_substitute_team: {},
    update_series_substitute_team:{},
    series_my_contests: {},
    SeriescreatePrivateContest: {},
    my_picks: {},
    series_contest_prize_preview: {},
    series_join_contest: {},
    series_pool_detail: {},
    series_clone_my_picks: {},
    edit_series_picks_save: {},
    series_contest_player_id: {},
    series_my_portfolio: {},
    series_match_list:{}
};

const seriesSlice = createSlice({
    name: "series",
    initialState,
    reducers: {
        RemoveSeriesCricketListing: (state) => {
            state.series_cricket_list = {};
        },
        ResetPoolSeriesData: (state) => {
            state.pool_series_list = {};
        },
        RemoveSeriesFootballListing: (state) => {
            state.series_football_list = {};
        },
        ResetContestTeamList: (state) => {
            state.series_contest_team_list = {};
        },
        ResetSeriesMyContestData: (state) => {
            state.series_my_contests = {};
        },
        ResetSeriesCreateContest: (state) => {
            state.SeriescreatePrivateContest = {}
        },
        ResetSeriesMyPicksData: (state) => {
            state.my_picks = {};
        },
        ResetSeriesContestPrizePreView: (state) => {
            state.series_contest_prize_preview = {};
        },
        ResetSeriesJoinContest: (state) => {
            state.series_join_contest = {};
        },
        ResetSeriesPoolDetailData: (state) => {
            state.series_pool_detail = {};
        },
        ResetSeriesCloneMyPicks: (state) => {
            state.series_clone_my_picks = {}
        },
        ResetSeriesEditPicksSaveData: (state) => {
            state.edit_series_picks_save = {}
        },
        ResetSeriesContestPlayerId: (state) => {
            state.series_contest_player_id = {}
        },
        ResetSeriesMyPortfolioList: (state) => {
            state.series_my_portfolio = {}
        },
        ResetSeriesSaveTeam: (state) => {
            state.series_save_team = {}
        },
        ResetSeriesMatchList: (state) => {
            state.series_match_list = {}
        },

        ResetUpdateSeriesSubstituteTeam: (state) => {
            state.update_series_substitute_team = {}
        }
    },
    extraReducers: {
        [SeriesCricketListingAsyncCall.pending]: (state) => {
            return { ...state, loading: true };
        },
        [SeriesCricketListingAsyncCall.fulfilled]: (state, { payload }) => {
            return { ...state, series_cricket_list: payload, loading: false };
        },
        [SeriesCricketListingAsyncCall.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [SeriesFootballListingAsyncCall.pending]: (state) => {
            return { ...state, loading: true };
        },
        [SeriesFootballListingAsyncCall.fulfilled]: (state, { payload }) => {
            return { ...state, series_football_list: payload, loading: false };
        },
        [SeriesFootballListingAsyncCall.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [PoolSeriesContestAsyncList.pending]: (state) => {
            return { ...state, loading: true };
        },
        [PoolSeriesContestAsyncList.fulfilled]: (state, { payload }) => {
            return { ...state, pool_series_list: payload, loading: false };
        },
        [PoolSeriesContestAsyncList.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [SeriesTeamAsyncList.pending]: (state) => {
            return { ...state, loading: true };
        },
        [SeriesTeamAsyncList.fulfilled]: (state, { payload }) => {
            return { ...state, series_contest_team_list: payload, loading: false };
        },
        [SeriesTeamAsyncList.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [ContestSeriesSaveTeamAction.pending]: (state) => {
            return { ...state, loading: true };
        },
        [ContestSeriesSaveTeamAction.fulfilled]: (state, { payload }) => {
            return { ...state, series_save_team: payload, loading: false };
        },
        [ContestSeriesSaveTeamAction.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [saveSubstitutePlayer.pending]: (state) => {
            return { ...state, loading: true };
        },
        [saveSubstitutePlayer.fulfilled]: (state, { payload }) => {
            return { ...state, series_substitute_team: payload, loading: false };
        },
        [saveSubstitutePlayer.rejected]: (state) => {
            return { ...state, loading: false };
        },

        
        [updateSubstitutePlayer.pending]: (state) => {
            return { ...state, loading: true };
        },
        [updateSubstitutePlayer.fulfilled]: (state, { payload }) => {
            return { ...state, update_series_substitute_team: payload, loading: false };
        },
        [updateSubstitutePlayer.rejected]: (state) => {
            return { ...state, loading: false };
        },


        [SeriesMyContestListAction.pending]: (state) => {
            return { ...state, loading: true };
        },
        [SeriesMyContestListAction.fulfilled]: (state, { payload }) => {
            return { ...state, series_my_contests: payload, loading: false };
        },
        [SeriesMyContestListAction.rejected]: (state) => {
            return { ...state, loading: false };
        },
        [SeriesCreatePrivatecontest.pending]: (state) => {
            return { ...state, loading: true };
        },
        [SeriesCreatePrivatecontest.fulfilled]: (state, { payload }) => {
            return { ...state, SeriescreatePrivateContest: payload, loading: false };
        },
        [SeriesCreatePrivatecontest.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [SeriesMypicks.pending]: (state) => {
            return { ...state, loading: true };
        },
        [SeriesMypicks.fulfilled]: (state, { payload }) => {
            return { ...state, my_picks: payload, loading: false };
        },
        [SeriesMypicks.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [SeriesContestPrizePreviewAction.pending]: (state) => {
            return { ...state, loading: true };
        },
        [SeriesContestPrizePreviewAction.fulfilled]: (state, { payload }) => {
            return { ...state, series_contest_prize_preview: payload, loading: false };
        },
        [SeriesContestPrizePreviewAction.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [SeriesJoinContestAction.pending]: (state) => {
            return { ...state, loading: true };
        },
        [SeriesJoinContestAction.fulfilled]: (state, { payload }) => {
            return { ...state, series_join_contest: payload, loading: false };
        },
        [SeriesJoinContestAction.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [PoolSeriesContestDetailAsyncList.pending]: (state) => {
            return { ...state, loading: true };
        },
        [PoolSeriesContestDetailAsyncList.fulfilled]: (state, { payload }) => {
            return { ...state, series_pool_detail: payload, loading: false };
        },
        [PoolSeriesContestDetailAsyncList.rejected]: (state) => {
            return { ...state, loading: false };
        },


        [SeriesCloneMyPicksAction.pending]: (state) => {
            return { ...state, loading: true };
        },
        [SeriesCloneMyPicksAction.fulfilled]: (state, { payload }) => {
            return { ...state, series_clone_my_picks: payload, loading: false };
        },
        [SeriesCloneMyPicksAction.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [EditSeriesPicksSaveAction.pending]: (state) => {
            return { ...state, loading: true };
        },
        [EditSeriesPicksSaveAction.fulfilled]: (state, { payload }) => {
            return { ...state, edit_series_picks_save: payload, loading: false };
        },
        [EditSeriesPicksSaveAction.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [getSeriesPlayerListIDAction.pending]: (state) => {
            return { ...state, loading: true };
        },
        [getSeriesPlayerListIDAction.fulfilled]: (state, { payload }) => {
            return { ...state, series_contest_player_id: payload, loading: false };
        },
        [getSeriesPlayerListIDAction.rejected]: (state) => {
            return { ...state, loading: false };
        },


        [ContestSeriesMyPortfolioAction.pending]: (state) => {
            return { ...state, loading: true };
        },
        [ContestSeriesMyPortfolioAction.fulfilled]: (state, { payload }) => {
            return { ...state, series_my_portfolio: payload, loading: false };
        },
        [ContestSeriesMyPortfolioAction.rejected]: (state) => {
            return { ...state, loading: false };
        },

        [SeriesMatchList.pending]: (state) => {
            return { ...state, loading: true };
        },
        [SeriesMatchList.fulfilled]: (state, { payload }) => {
            return { ...state, series_contest_team_list: payload, loading: false };
        },
        [SeriesMatchList.rejected]: (state) => {
            return { ...state, loading: false };
        },
    }
})

export const { RemoveSeriesCricketListing, RemoveSeriesFootballListing, ResetPoolSeriesData, ResetContestTeamList, ResetSeriesMyContestData, ResetSeriesCreateContest, ResetSeriesMyPicksData, ResetSeriesContestPrizePreView, ResetSeriesJoinContest, ResetSeriesPoolDetailData, ResetSeriesCloneMyPicks, ResetSeriesEditPicksSaveData, ResetSeriesContestPlayerId, ResetSeriesMyPortfolioList, ResetSeriesSaveTeam,
    ResetUpdateSeriesSubstituteTeam } = seriesSlice.actions;
export const getCricketSeriesListingData = (state) => state.series.series_cricket_list;
export const getFootballSeriesListingData = (state) => state.series.series_football_list;
export const getPoolSeriesData = (state) => state.series.pool_series_list;
export const getContestTeamData = (state) => state.series.series_contest_team_list;
export const getSaveTeamData = (state) => state.series.series_save_team;
export const getSaveSubstituteData = (state) => state.series.series_substitute_team;
export const getUpdateSubstituteData = (state) => state.series.update_series_substitute_team;
export const getSeriesMyContestData = (state) => state.series.series_my_contests;
export const getSeriesCreateContestData = (state) => state.series.SeriescreatePrivateContest;
export const getSeriesMyPicksData = (state) => state.series.my_picks;
export const getSeriesPrizePreviewData = (state) => state.series.series_contest_prize_preview;
export const getSeriesJoinContestData = (state) => state.series.series_join_contest;
export const getSeriesPoolDetailsData = (state) => state.series.series_pool_detail;
export const getSeriesClonePicksData = (state) => state.series.series_clone_my_picks;
export const getSeriesEditPicksSaveData = (state) => state.series.edit_series_picks_save;
export const getSeriesPlayerIdData = (state) => state.series.series_contest_player_id;
export const getSeriesPortfolioList = (state) => state.series.series_my_portfolio;
export const getSeriesMatchData = (state) => state.series.series_match_list;

export default seriesSlice.reducer;
